module.exports = __webpack_public_path__ + "media/components/eligibilityQuestions/icons/search-f41b86bc1e308aad7ac29fb7876be4fe.svg";